import React, { useEffect, useState } from 'react';
import styles from './b2c.module.scss';
import { KoButton, KoInput, KoLoader, KoNano, KoOTP, KoText, KoTitle } from 'packages';
import { Layout } from 'antd';
import KoIcon from '@kwapio/icons';
import { Link, Outlet, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { B2CAPI } from './b2c.service';
import { getCookie, setCookie } from 'shared/utils/cookies';
import { identifyEmailOrMobile } from 'shared/utils';
export default function B2Customers({ formData }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const [accountDetails, setAccountDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [otp, onChangeOtp] = useState();
  const currentPath = pathname?.split('/')[1];
  const [activeLink] = useState(currentPath);
  const tempTokens = getCookie('tempToken');
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get("request");
  const [email, setEmail] = useState(requestId);
  const [tempToken, setTempToken] = useState(tempTokens);
  const [contact, setEmailId] = useState();

  console.log(otp);
  const { Header } = Layout;
  const { accountId } = useParams();
  useEffect(() => {

    B2CAPI.getByIdSettings(accountId).then(
      (data) => {
        setAccountDetails(data['account']);
        setLoading(false);
      },
      () => setLoading(false)
    );

  }, []);

  useEffect(() => {
    if (getCookie('tempToken')) {
      setTempToken(getCookie('tempToken'));
            //   getRecentTicket();
    }

  }, []);


  const validateUsers = () => {
    let object = identifyEmailOrMobile(contact);
    B2CAPI.validateUsers(object, accountId).then(
      (data) => {
        if(!data?.exists){
          let createObj={
            companyName:object.email.split('@')[0],
            email:object.email,
            customerId:KoNano('CUS')
          };
          B2CAPI.createUsers(createObj).then(
            (data) => {
              onEnterEmail(object);
              setLoading(false);
            },
            (err) => {
              setLoading(false);
            }
          );
        }else{
          onEnterEmail(object);
        }
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onEnterEmail = (obj) => {
    setLoading(true);

    if(obj.email){
      setEmail(obj.email);

    }else{
      setEmail(obj.mobile);
    }

    B2CAPI.getValidateEmail(obj).then(
      (data) => {
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );

  };

  const handleFinish = (email) => {
    setLoading(true);
    let obj = {
      customer: email,
      otp: otp,
      accountId,
      mobile:'9944929666'
      
    };
    B2CAPI.verifyOtp(obj).then(
      (data) => {
        setLoading(false);
        setCookie('tempToken', data?.token);
        setTempToken(data?.token);
        // getRecentTicket();
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const maskEmail = (email) => {
    if (!email || !email.includes("@")) return email;
    const [name, domain] = email.split("@");
    const visiblePart = name.slice(0, 3);
    return `${visiblePart}***@${domain}`;
  };

  return (
    tempToken ? <div className={styles.wrapper}>
      {loading && <KoLoader />}
      <Header className={styles.shallowHeader}>
      </Header>
      <Header className={`${styles.header}`}>
        <div className={styles.topNavHeader}>
          <div className={styles.topNavHeaderMain}>
            <div className={styles.topNavHeaderMainLeft} onClick={() => navigate('/home/feed')}>
              <div className={styles.logo}>
                <KoIcon name='AppLogoFilled' width={115} height={25} />
              </div>
            </div>
            <div className={`${styles.topNavHeaderMenu} topNav`}>
              <ul>
                {[
                  {
                    key: 'requests',
                    link: 'requests',
                    icon: 'ChoiceOutlined',
                    text: 'Requests',
                    active: true
                  },
                  {
                    key: 'support',
                    link: 'support',
                    icon: 'SupportPortalOutlined',
                    text: 'Support',
                    active: true
                  },
                  {
                    key: 'orders',
                    link: 'orders',
                    icon: 'OrdersOutlined',
                    text: 'Orders',
                    active: true
                  },
                  {
                    key: 'mydrive',
                    link: 'mydrive',
                    icon: 'DocumentsOutlined',
                    text: 'Drive',
                    active: true
                  },
                  {
                    key: 'engagements',
                    link: 'engagements',
                    icon: 'EngagementsOutlined',
                    text: 'Engagements',
                    active: true
                  }
                ].map((item) => {
                  if (item.active) {
                    return (
                      <li key={item.key} className={(activeLink === item.key || (item.key === 'requests' && activeLink === 'requests')) ? styles.active : ''}>
                        <Link to={item.link}>
                          <KoIcon name={item.icon} />
                          <KoText ellipsis={true} className={styles.text} text={item.text} />
                        </Link>
                      </li>
                    );
                  }
                  return null;
                })}

              </ul>

            </div>

            <div className={styles.headerBtnRightContent}>
            </div>
            <div className={styles.headerActionsAvatar}>
              <div className={styles.userWrapper} >
                {accountDetails?.companyName && <KoText ellipsis={true} className={styles.name} text={`${accountDetails?.companyName}.`} />}
                <div className={`${styles.headCircle}  ${styles['k']}`}>
                  <KoText className={`${styles.letter}`} text={'K'} />
                </div>
              </div>

            </div>
          </div>
        </div>
      </Header>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div> :
      <div className={styles.wrapper}>
        {email ? <div className={styles.modalWrapper}>
          <div className={styles.logo}>
            <KoIcon name='AppLogoFilled' width={115} height={25} />
          </div>
          <KoTitle text={'Code Verification'} level={1} className={styles.title} />
          <KoText text={`We've sent code to your email ${maskEmail(email)}`} className={`${styles.smallOtp}`} />
          <div className={styles.otpWrapper}>
            <KoTitle text={'Code Verification'} level={4} className={styles.title} />
            <div className={styles.formWrapperOtps}>
              <KoOTP onChangeOtp={onChangeOtp} numInputs={4} />
              <KoButton type='primary' onClick={() => handleFinish(email)} text={'Verify Account'} className={styles.signupBtn} />
            </div>
          </div>
          <div className={styles.signupBtn}>
            <KoText text={` Didn't receive code?`}  />
            <KoText onClick={() => { onEnterEmail({email}); }} text={` Resend`} className={`${styles.link}`} />
          </div>
        </div>: <div className={styles.modalWrapper}>
          <div className={styles.logo}>
            <KoIcon name='AppLogoFilled' width={115} height={25} />
          </div>
          <KoTitle text={'Verification Required'} level={1} className={styles.title} />
          <KoText text={`A verification code will be sent to your registered email or phone number. Enter the code to proceed securely.`} className={`${styles.smallOtp}`} />
          <div className={styles.otpWrapper}>
            <div className={styles.formWrapperOtp}>
              <KoInput placeholder='Enter email' onChange={(e) => setEmailId(e.target.value)} />
              <KoButton type='primary' onClick={validateUsers} text={'Get Code'} className={styles.signupBtn} />
            </div>
          </div>
        </div>}
      </div>
  );
}
